const apiConstants = {
  prefix: '/api/'
};

export default apiConstants;
